export const PERSIST = 'persist/PERSIST';

/**
 * Enum for persist modes.
 * @readonly
 * @enum {string}
 */
export const PERSIST_MODES = Object.freeze({
    REPLACE: 'replace', // overwrite at path (removes old keys by replacement)
    UPDATE: 'update', // patch/merge at path (keeps old keys)
    DELETE: 'delete', // remove path
});
